"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPENDING_SPLIT_CONFIRMED_COPY = exports.SPENDING_SPLIT_DETECTED_COPY = exports.BILLS_CONFIRMED_COPY = exports.BILLS_DETECTED_COPY = exports.INCOME_CONFIRMED_COPY = exports.INCOME_DETECTED_COPY = void 0;
/**
 * The setup review rows, confirmed and not (#733, AN-34). One copy for both apps:
 * web's financial-analysis section 8 and mobile's review step said these words
 * separately. A row reads "confirmed" only when the server's map says so.
 */
exports.INCOME_DETECTED_COPY = "Income: detected, please review";
exports.INCOME_CONFIRMED_COPY = "Income confirmed";
exports.BILLS_DETECTED_COPY = "Recurring bills: detected, please review";
exports.BILLS_CONFIRMED_COPY = "Recurring bills confirmed";
exports.SPENDING_SPLIT_DETECTED_COPY = "Spending split: detected, please review";
exports.SPENDING_SPLIT_CONFIRMED_COPY = "Spending split confirmed";
//# sourceMappingURL=setupConfirmationsCopy.js.map